export default __webpack_public_path__ + "static/media/toolcertificate-en-transparent.08d1b325.png";